import { cn } from "@/lib/utils";

/** Full-viewport one-pager atmosphere shared by authentication surfaces. */
export function AuthShell({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "relative isolate flex min-h-svh flex-col items-center justify-center overflow-hidden bg-[#f3f0ea] p-4 pb-0 text-[#332b32] [color-scheme:light] dark:bg-[#1b131b] dark:text-[#f7f3f0] dark:[color-scheme:dark]",
        className,
      )}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-20 bg-[radial-gradient(ellipse_72%_56%_at_50%_45%,rgba(117,78,104,0.24),transparent_68%),linear-gradient(135deg,#f8f6f1_0%,#eee9e3_48%,#f5f1ed_100%)] dark:bg-[radial-gradient(ellipse_72%_56%_at_50%_45%,rgba(154,96,137,0.28),transparent_68%),linear-gradient(135deg,#160f16_0%,#241823_48%,#160f16_100%)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 opacity-[0.18] [background-image:linear-gradient(rgba(108,44,89,0.14)_1px,transparent_1px),linear-gradient(90deg,rgba(108,44,89,0.14)_1px,transparent_1px)] [background-size:3px_3px] [mask-image:radial-gradient(ellipse_54%_44%_at_50%_46%,black,transparent_78%)] dark:opacity-[0.11]"
      />
      {children}
    </div>
  );
}

export function AuthLoadingScreen({ message }: { message: string }) {
  return (
    <AuthShell>
      <div className="flex flex-col items-center gap-4">
        <div className="size-11 animate-spin rounded-full border-2 border-[#6c2c59]/20 border-t-[#6c2c59]" />
        <p className="text-sm text-[#796a74] dark:text-[#b7a9b2]">{message}</p>
      </div>
    </AuthShell>
  );
}
